/* tslint:disable:no-string-literal */
import Vue from 'vue';
import VueAxios from 'vue-axios';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import Vue2Filters from 'vue2-filters';
import { abilitiesPlugin } from '@casl/vue';
import moment from 'moment';

import App from './App.vue';
import router from './router';
import store from './store';
import './registerServiceWorker';
import ability from './ability';
import axiosInstance from './axios';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import vuePivotTable from '@click2buy/vue-pivot-table';

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
// Init plugin
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)

// Components
import './components';

Vue.config.productionTip = false;
Vue.use(vuePivotTable)

Vue.filter('formatDate', (value) => {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY');
  }
});

Vue.filter('formatDateTime', (value) => {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY  HH:mm:ss');
  }
});

Vue.filter('formatDateWithoutTimeZone', (value) => {
  if (value) {
    return moment.utc(String(value)).format('DD/MM/YYYY');
  }
});

Vue.filter('firstLetter', (value) => {
  if (!value || typeof value !== 'string') {
    return '';
  }
  if (value.length <= length) {
    return value;
  }
  return value.substring(0, 1);
});

Vue.use(VueAxios, axiosInstance);
Vue.use(Vuetify, {
  theme: {
    primary: '#1976D2',
    secondary: '#424242',
    accent: '#82B1FF',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107',
  },
});
Vue.use(Vue2Filters);
Vue.use(abilitiesPlugin, ability);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
